const TOAST_PREFIX = '@TOAST';

export const SHOW = `${TOAST_PREFIX}/SHOW`;
export const HIDE = `${TOAST_PREFIX}/HIDE`;
